import { useState, useEffect, useRef } from 'react';

function useLocalStorage(key, initialValue) {
  const initialValueRef = useRef(initialValue);
  const [value, setValue] = useState(() => {
    try {
      const saved = localStorage.getItem(key);
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        return parsed !== null ? parsed : initialValueRef.current;
      }
      return initialValueRef.current;
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      return initialValueRef.current;
    }
  });

  // If the key changes (e.g. user-specific namespace), reload from localStorage.
  useEffect(() => {
    try {
      const saved = localStorage.getItem(key);
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        setValue(parsed !== null ? parsed : initialValueRef.current);
      } else {
        setValue(initialValueRef.current);
      }
    } catch (error) {
      console.error(`Error reloading localStorage key "${key}":`, error);
      setValue(initialValueRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  }, [key, value]);

  return [value, setValue];
}

export default useLocalStorage;
